import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import OnboardingPage from './pages/OnboardingPage';
import AboutPage from './pages/AboutUs';
import ContactPage from './pages/ContactUs';
import PricingPage from './pages/pricingpage';
import NotFound from './Components/NotFound';
import LocationPage from './SEOFRINDLY/LocationPage';
import BlogPage from './pages/BlogPage';
import MarketingPage from './pages/MarkitingPage';
import Attendancesystem from './Product/Attendancesystem';
import LoadingSpinner from './Components/Common/LoadingSpinner';
import EcommerceDevelopment from './pages/ServicePages/EcommerceDevelopment';
import MobileAppDevelopment from './pages/ServicePages/MobileAppDevelopment';
import ServicesPage from './pages/ServicePages/ServicesPage';
import Careers from './pages/CareersPage';
import LeadershipPage from './pages/LeadershipPage';
import CookiePolicyPage from './pages/CookiePolicy';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function AppRoutes() {
  return (
    <Routes>
      {/* Core Pages */}
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/careers" element={<Careers />} />

      {/* Services */}
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/ecommerce-development" element={<EcommerceDevelopment />} />
      <Route path="/mobile-app-development" element={<MobileAppDevelopment />} />
      <Route path="/enterprise-solutions" element={<ServicesPage />} />

      {/* Products */}
      <Route path="/attendancesystem" element={<Attendancesystem />} />

      {/* Digital Marketing */}
      <Route path="/digital-marketing" element={<MarketingPage />} />
      <Route path="/digital-marketing/:service" element={<MarketingPage />} />

      {/* Blog */}
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPage />} />
      <Route path="/faq" element={<BlogPage />} />

      {/* Service + Location combinations */}
      <Route path="/services/:location/:service" element={<BlogPage />} />

      {/* Legacy redirects */}
      <Route path="/web-development" element={<Navigate replace to="/digital-marketing" />} />
      <Route path="/software-development" element={<Navigate replace to="/digital-marketing" />} />
      <Route path="/app-development" element={<Navigate replace to="/digital-marketing" />} />
      <Route path="/website-development" element={<Navigate replace to="/digital-marketing" />} />
      <Route path="/custom-software-development" element={<Navigate replace to="/digital-marketing" />} />

      {/* Location pages - major cities */}
      <Route path="/gorakhpur" element={<LocationPage location="Gorakhpur" />} />
      <Route path="/gorakhpur/best-software-development-company-in-gorakhpur" element={<LocationPage location="Gorakhpur" />} />
      <Route path="/Gorakhpur" element={<Navigate replace to="/gorakhpur" />} />

      <Route path="/delhi" element={<LocationPage location="Delhi" />} />
      <Route path="/delhi/best-software-development-company-in-delhi" element={<LocationPage location="Delhi" />} />
      <Route path="/Delhi" element={<Navigate replace to="/delhi" />} />

      <Route path="/patna" element={<LocationPage location="Patna" />} />
      <Route path="/patna/best-software-development-company-in-patna" element={<LocationPage location="Patna" />} />
      <Route path="/Patna" element={<Navigate replace to="/patna" />} />

      <Route path="/lucknow" element={<LocationPage location="Lucknow" />} />
      <Route path="/lucknow/best-software-development-company-in-lucknow" element={<LocationPage location="Lucknow" />} />
      <Route path="/Lucknow" element={<Navigate replace to="/lucknow" />} />

      <Route path="/bihar" element={<LocationPage location="Bihar" />} />
      <Route path="/bihar/best-software-development-company-in-bihar" element={<LocationPage location="Bihar" />} />
      <Route path="/Bihar" element={<Navigate replace to="/bihar" />} />

      <Route path="/punjab" element={<LocationPage location="Punjab" />} />
      <Route path="/punjab/best-software-development-company-in-punjab" element={<LocationPage location="Punjab" />} />
      <Route path="/Punjab" element={<Navigate replace to="/punjab" />} />

      {/* Metro cities */}
      <Route path="/bangalore" element={<LocationPage location="Bangalore" />} />
      <Route path="/hyderabad" element={<LocationPage location="Hyderabad" />} />
      <Route path="/pune" element={<LocationPage location="Pune" />} />
      <Route path="/chennai" element={<LocationPage location="Chennai" />} />
      <Route path="/mumbai" element={<LocationPage location="Mumbai" />} />
      <Route path="/kolkata" element={<LocationPage location="Kolkata" />} />
      <Route path="/gurgaon" element={<LocationPage location="Gurgaon" />} />
      <Route path="/noida" element={<LocationPage location="Noida" />} />

      {/* Other locations */}
      <Route path="/himachal" element={<LocationPage location="Himachal" />} />
      <Route path="/Himachal" element={<Navigate replace to="/himachal" />} />
      <Route path="/faridabad" element={<LocationPage location="Faridabad" />} />
      <Route path="/Faridabad" element={<Navigate replace to="/faridabad" />} />
      <Route path="/uk" element={<LocationPage location="UK" />} />
      <Route path="/UK" element={<Navigate replace to="/uk" />} />
      <Route path="/mohali" element={<LocationPage location="Mohali" />} />
      <Route path="/Mohali" element={<Navigate replace to="/mohali" />} />
      <Route path="/chandigarh" element={<LocationPage location="Chandigarh" />} />
      <Route path="/Chandigarh" element={<Navigate replace to="/chandigarh" />} />
      <Route path="/uttarpradesh" element={<LocationPage location="Uttar Pradesh" />} />
      <Route path="/UttarPradesh" element={<Navigate replace to="/uttarpradesh" />} />
      <Route path="/india" element={<LocationPage location="India" />} />

      {/* Utility */}
      <Route path="/loading" element={<LoadingSpinner />} />
      <Route path="/404" element={<NotFound />} />

      {/* Internal — not linked anywhere on the site, shared directly with new hires */}
      <Route path="/onboarding" element={<OnboardingPage />} />
      {/* Legal & Company pages */}
      <Route path="/leadership" element={<LeadershipPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/cookies" element={<CookiePolicyPage />} />

      <Route path="*" element={<Navigate replace to="/404" />} />

    </Routes>
  );
}

export default AppRoutes;
